import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';

import { notifyMessageAction } from 'store/notification/action';

import {
  LOAD_PATIENT_LIST,
  LOAD_CURRENT_MANAGE_PATIENT_LIST,
  CREATE_PATIENT,
  LOAD_PATIENT_DETAIL,
  UPDATE_PATIENT,
} from '../type';
import {
  loadPatientListSuccessAction,
  loadPatientListErrorAction,
  loadPatientDetailSuccessAction,
  loadPatientDetailErrorAction,
  createPatientSuccessAction,
  createPatientErrorAction,
  updatePatientSuccessAction,
  updatePatientErrorAction,
  loadCurrentListPatientSuccessAction,
  loadCurrentListPatientErrorAction,
} from '../action';

import { patientService } from 'services';

import { NOTIFICATION_TYPE } from 'common/enum';

function* loadPatientList() {
  while (1) {
    const action = yield take(LOAD_PATIENT_LIST);
    try {
      const listPatient = yield call(
        patientService.loadPatientList,
        action.payload,
      );
      yield put(loadPatientListSuccessAction(listPatient));
    } catch (err) {
      yield put(loadPatientListErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}
//load list for current manage patient

function* loadPatientListForCurrentManage() {
  while (1) {
    const action = yield take(LOAD_CURRENT_MANAGE_PATIENT_LIST);
    try {
      const listPatient = yield call(
        patientService.loadPatientListForCurrentManage,
        action.payload,
      );
      yield put(loadCurrentListPatientSuccessAction(listPatient));
    } catch (err) {
      yield put(loadCurrentListPatientErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* loadPatientDetail() {
  while (1) {
    const action = yield take(LOAD_PATIENT_DETAIL);
    try {
      const patientDetail = yield call(
        patientService.loadPatientDetail,
        action.payload,
      );
      yield put(loadPatientDetailSuccessAction(patientDetail));
    } catch (err) {
      yield put(loadPatientDetailErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* createPatient() {
  while (1) {
    const action = yield take(CREATE_PATIENT);
    try {
      const createdPatient = yield call(
        patientService.createPatient,
        action.payload,
      );
      const organisationId =
        action.payload.organisationId || createdPatient.companies[0].companyId;
      yield put(createPatientSuccessAction(createdPatient));

      yield put(
        notifyMessageAction({
          message: {
            id: 'app.patient.create-success.toast',
          },
        }),
      );
      if (action.payload.callback) {
        action.payload.callback(createdPatient, organisationId);
      }
    } catch (err) {
      yield put(createPatientErrorAction(err));
      yield put(
        notifyMessageAction({
          type: NOTIFICATION_TYPE.ERROR,
          message: {
            id: err.message,
          },
        }),
      );
    }
  }
}

function* updatePatient() {
  while (1) {
    const action = yield take(UPDATE_PATIENT);
    try {
      const updatedPatient = yield call(
        patientService.updatePatient,
        action.payload,
      );
      const callBack = action.payload.callback;

      if (callBack) {
        callBack();
      }
      yield put(updatePatientSuccessAction(updatedPatient));
      notification.success({
        message: 'Candidate/patient has been successfully updated',
      });
    } catch (err) {
      yield put(updatePatientErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

export default function* rootSaga() {
  yield all([
    loadPatientList(),
    loadPatientListForCurrentManage(),
    createPatient(),
    loadPatientDetail(),
    updatePatient(),
  ]);
}
